import {Github, Linkedin} from 'lucide-react';
import {memo, ReactElement} from 'react';
import contactJson from 'static_configs/contact.json';
import {ContactContent, LinkItem} from 'types';

const content = contactJson as ContactContent;

function SocialIcon({link}: { link: LinkItem }): ReactElement {
  if (link.label === 'LinkedIn') {
    return <Linkedin aria-hidden="true" />;
  }

  return <Github aria-hidden="true" />;
}

function ContactSection(): ReactElement {
  return (
    <div className="section-inner contact-root">
      <div className="contact-panel">
        <div className="title-container">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2>{content.title}</h2>
          <p>{content.body}</p>
        </div>

        <div className="social-container">
          {content.socialLinks.map((link) =>
            <a key={link.href} className="button button-secondary social-card-action" href={link.href}>
              <SocialIcon link={link} />
              <span>{link.label}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export const Contact = memo(ContactSection);
